import service from "../utils/request";

export function updateStockCheckStatus(stockCheck) {
  // 直接将stockCheck对象作为请求体发送，不包装在data对象中
  return service.post("/uic-system_hf/stockcheck/updateStatus", stockCheck);
}

/**
 * 根据编码获取供应商
 */
export function getSupplierByCode(code) {
  return service.get("/uic-system/supplier/page", {
    params: {
      supplierCode: code,
      current: 1,
      size: 1,
    },
  });
}

/**
 * 根据供应商和编码获取物料
 */
export function getMaterialBySupplierAndNo(params) {
  // 确保参数正确传递，只包含必要字段
  const queryParams = {
    supplierId: params.supplierId,
    current: params.current || 1,
    size: params.size || 20,
  };

  // 只有当物料编码存在时才添加到参数中
  if (params.materialNo && params.materialNo.trim()) {
    queryParams.materialNo = params.materialNo;
  }

  return service.get("/uic-system/material/page", { params: queryParams });
}

/**
 * 获取仓库列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词
 * @returns {Promise}
 */
export function getWarehouses(params) {
  return service.get("/uic-system/ware/page", {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      bizDept: params.bizDept || "",
      wareType: 0,
      wareName: params.keyword || "",
    },
  });
}

export function getWareList(params) {
  return service.get("/uic-system/ware/list", {
    params: {
      wareType: 0,
      bizDept: params?.bizDept || "",
    },
  });
}

/**
 * 获取库位列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词
 * @param {string} params.warehouseId - 仓库ID (作为parentId传递)
 * @returns {Promise}
 */
export function getLocations(params) {
  return service.get("/uic-system/ware/page", {
    params: {
      parentId: params.warehouseId || "",
      wareType: 2,
      current: params.current || 1,
      size: params.size || 20,
      wareName: params.keyword || "",
    },
  });
}

/**
 * 获取物料列表
 * @param {Object} params - 查询参数
 * @param {string} params.supplierId - 供应商ID
 * @param {string} params.storeId - 仓库ID
 * @param {number} params.isBad - 是否不良品(0:正常,1:不良)
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function getMaterials(params) {
  return service.get("/uic-system/material/page", {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      supplierId: params.supplierId || "",
      storeId: params.storeId || "",
      // isBad: params.isBad || 0
    },
  });
}

/**
 * 保存盘点记录
 * @param {Object} data - 盘点数据
 * @returns {Promise}
 */
export function saveStockCheck(data) {
  return service.post("/uic-system/stockCheck/save", data);
}

export function changePalletLocation(data) {
  return service.post("/uic-system_hf/stockcheck/pallet/change", data);
}

export function qualityTransferMove(data) {
  return service.post("/uic-system_hf/stockcheck/move", data);
}

/**
 * 获取盘点历史记录
 * @param {Object} params - 查询参数
 * @param {string} params.warehouseId - 仓库ID
 * @param {string} params.materialNo - 物料编码
 * @param {string} params.startDate - 开始日期
 * @param {string} params.endDate - 结束日期
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
// 确保API路径正确
// 修改getStockCheckHistory函数，添加更多参数支持查询
export function getStockCheckHistory(params) {
  return service.get("/uic-system_hf/stockcheck/page1", {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      checkStatus: params.checkStatus ?? params.status,
      deptName: params.deptName || "",
      supplierName: params.supplierName || "",
      materialGroupId: params.materialGroupId,
      inventeType: params.inventeType ?? 0,
    },
  });
}

// // 确保copyStockToStockCheck路径正确
export function copyStockToStockCheck(ids) {
  return service.post("/uic-system_hf/stockcheck/add", null, {
    params: {
      ids: ids.join(","),
    },
  });
}

/**
 * 获取供应商列表（带分页和搜索）
 * @param {Object} params - 查询参数
 * @param {number} params.current - 当前页码
 * @param {number} params.size - 每页条数
 * @param {string} params.keyword - 搜索关键词
 * @returns {Promise}
 */
export function getSuppliers(params) {
  return service.get("/uic-system/supplier/page", {
    params: {
      current: params.current || params.currentPage || 1,
      size: params.size || params.pageSize || 20,
      supplierName: params.keyword || "",
    },
  });
}

/**
 * 批量导入供应商库存数据
 * @param {Array<number>} ids - 供应商ID列表
 * @returns {Promise}
 */
// 删除重复的函数定义
// export function copyStockToStockCheck(ids) {
//   return service.post('uic-system_hf/stockcheck/add', null, {
//     params: {
//       ids: ids.join(',')  // 将数组转换为逗号分隔的字符串
//     }
//   });
// }

/**
 * 获取盘点详情
 * @param {number} id - 盘点单ID
 * @returns {Promise}
 */
export function getId(id) {
  return service.get("/uic-system_hf/stockcheck/detail", {
    params: { id },
  });
}

/**
 * 更新盘点详情
 * @param {Object} data - 盘点详情数据
 * @param {string} data.inventeId - 盘点单ID
 * @param {string} data.materialId - 物料ID
 * @param {string} data.batchNo - 批次号
 * @param {number} data.actualNum - 实际盘点数量
 * @param {string|number} [data.palletId] - 托盘ID（库位盘点需传）
 * @param {string} [data.palletCode] - 托盘码
 * @param {string} [data.remark] - 备注
 * @param {number} [data.isBad] - 是否不良品
 * @returns {Promise}
 */
export function updateStockCheckDetail(data) {
  return service.post(
    "/uic-system_hf/stockCheckDetail/updateStockCheckDetail",
    data,
  );
}

/**
 * 更新盘点状态
 * @param {Object} data - 盘点状态数据
 * @returns {Promise}
 */
export function updateCheckStatus(stockCheckStatus) {
  return service.post(
    "/uic-system_hf/stockCheckStatus/updateCheckStatus",
    stockCheckStatus,
  );
}

/**
 * 根据物料编码创建盘点单
 * @param {string} materialNo - 物料编码
 * @returns {Promise}
 */
export function createCheckByMaterialNo(materialNo) {
  return service.post("/uic-system_hf/stockcheck/materialNoAdd", null, {
    params: {
      materialNo: materialNo,
    },
  });
}

export function materialNoSave(params) {
  return service.post("/uic-system_hf/stockcheck/materialNoSave", params, {
    params,
  });
}

/**
 * 创建项目组盘点单
 * @param {Object} params - 盘点单参数
 * @param {string} params.materialGroupId - 项目组ID
 * @param {string} params.supplierIds - 供应商ID列表（逗号分隔）
 * @param {string} params.materialIds - 物料ID列表（逗号分隔）
 * @returns {Promise}
 */
export function addStockCheck(params) {
  return service.post("/uic-system_hf/stockcheck/stockcheckAdd", params);
}

/**
 * 现场盘点添加
 * @param {Object} params - 盘点参数
 * @param {string} params.bizDept - 项目组ID
 * @returns {Promise}
 */
export function stockcheckAddByBizDept(params) {
  return service.post(
    "/uic-system_hf/stockcheck/stockcheckAddByBizDept",
    params,
  );
}

export function warehouseSaveStockCheck(params) {
  return service.post("/uic-system_hf/stockcheck/warehouseSave", params);
}

/**
 * 按供应商维度创建盘点单
 * @param {Object} params
 * @param {string} params.bizDept - 项目组ID
 * @param {string} params.storeId - 仓库ID
 * @param {string} params.supplierIds - 供应商ID
 * @returns {Promise}
 */
export function supplierSaveStockCheck(params) {
  return service.post("/uic-system_hf/stockcheck/supplierSave", params);
}

export function deleteStockCheck(id) {
  return service.delete("/uic-system_hf/stockcheck/delete", {
    params: {
      id,
    },
  });
}

/**
 * 新增盘点详情
 * @param {Object} params - 盘点详情参数
 * @param {number} params.inventeId - 盘点单ID
 * @param {number} params.supplierId - 供应商ID
 * @param {string} params.materialNo - 物料编码
 * @returns {Promise}
 */
export function addStockCheckDetail(params) {
  return service.post("/uic-system_hf/stockCheckDetail/addStockCheckDetail", {
    inventeId: params.inventeId,
    supplierId: params.supplierId,
    materialNo: params.materialNo,
  });
}

/**
 * 获取盘点详情列表（分页）
 * @param {Object} params - 查询参数
 * @param {string} params.materialGroupId - 项目组ID
 * @param {number} params.current - 当前页码
 * @param {number} params.size - 每页条数
 * @param {number} params.status - 状态
 * @param {string} params.inventeId - 盘点单ID
 * @returns {Promise}
 */
/**
 * 库位盘点-分页查询
 * @param {Object} params - 查询参数
 * @param {number} params.current - 当前页码
 * @param {number} params.size - 每页条数
 * @param {number} params.checkStatus - 盘点状态
 * @param {string} params.wareName - 库位名称
 * @returns {Promise}
 */
export function getWareCheckPage(params) {
  return service.get("/uic-system_hf/stockcheck/warePage", {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      checkStatus: params.checkStatus,
      wareName: params.wareName || "",
      inventeType: params.inventeType ?? 0,
    },
  });
}

/**
 * 库位盘点-通过托盘码新增盘点单
 * @param {string} palletCode - 托盘码
 * @returns {Promise}
 */
export function warehouseCheckByPallet(palletCode) {
  return service.post("/uic-system_hf/stockcheck/warehouse/check", null, {
    params: { palletCode },
  });
}

/**
 * 查询物料库位信息
 * @param {Object} params - 查询参数
 * @param {string} params.materialId - 物料ID
 * @param {string} params.materialNo - 物料编码
 * @param {number} params.current - 当前页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function getMaterialStockPage(params) {
  return service.get("/uic-system/hf_materialstock/page", {
    params: {
      materialId: params.materialId || "",
      materialNo: params.materialNo || "",
      current: params.current || 1,
      size: params.size || 20,
    },
  });
}

export function getStockCheckDetailPage(params) {
  return service.get("/uic-system_hf/stockcheck/page", {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      status: params.status,
      isBad: params.isBad,
      materialNo: params.materialNo || "",
      inventeId: params.inventeId || "",
      isInvente: params.isInvente,
    },
  });
}
